import { getStateStore } from '../../stores';
import { updateConfig as updateHostConfig } from '../peers/host';
import { updateConfig as updateRemoteHostConfig } from '../peers/remoteControl';

const state = getStateStore('ipc');

export const initializeIceServerEvents = () => {
  state.iceServerState.addListener((iceServerState) => {
    console.log('[ICE-SERVER-STATE] State:', iceServerState);

    updateHostConfig({
      forceTurn: !iceServerState.allowPeerConnections,
      iceServers: iceServerState.hostIceServers,
    });
    updateRemoteHostConfig({
      forceTurn: !iceServerState.allowPeerConnections,
      iceServers: iceServerState.remoteHostIceServers,
    });
  });
};
